// WhatsApp click-to-chat helpers.
// A wa.me link opens a chat with a pre-typed message; it cannot attach files.
// Numbers must include the full country code — we only strip non-digits.

export const getWhatsAppNumber = (employee) => {
  if (!employee) return '';
  return (employee.whatsapp_no || employee.phone || '').trim();
};

export const openWhatsApp = (rawNumber, message = '') => {
  const digits = (rawNumber || '').replace(/\D/g, '');
  if (!digits) {
    alert('No WhatsApp or phone number is saved for this staff member. Add one in the employee profile.');
    return false;
  }
  const url = `https://wa.me/${digits}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
  window.open(url, '_blank', 'noopener,noreferrer');
  return true;
};
